import { apiUrl } from "../../common/api/config";

export const getMyProjects = async () => {
  try {
    const token = localStorage.getItem("accessToken");

    const response = await fetch(apiUrl + "/projects/my-projects/", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });

    const responseData = await response.json();

    if (response.ok) {
      return responseData;
    } else {
      throw new Error(responseData.errors);
    }
  } catch (error) {
    throw new Error(error);
  }
};

export const getProjectMembers = async () => {
  try {
    const token = localStorage.getItem("accessToken");

    const response = await fetch(apiUrl + "/projects/users/", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });

    const responseData = await response.json();

    if (response.ok) {
      return responseData;
    } else {
      throw new Error(responseData.errors);
    }
  } catch (error) {
    throw new Error(error);
  }
};

export const getProjectInfo = async () => {
  try {
    const token = localStorage.getItem("accessToken");

    const response = await fetch(apiUrl + "/projects/info/", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });

    const responseData = await response.json();

    if (response.ok) {
      return responseData;
    } else {
      throw new Error(responseData.errors);
    }
  } catch (error) {
    throw new Error(error);
  }
};

export const switchProject = async (project_id) => {
  try {
    const token = localStorage.getItem("accessToken");

    const data = {
      project_id: project_id,
    };

    const response = await fetch(apiUrl + "/projects/switch-project/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(data),
    });

    const responseData = await response.json();

    return responseData;
  } catch (error) {
    return error;
  }
};

export const updateProjectInfo = async (data) => {
  try {
    const token = localStorage.getItem("accessToken");

    // Check if data is FormData (for file uploads) or regular object
    const isFormData = data instanceof FormData;

    const headers = {
      Authorization: "Bearer " + token,
    };

    // Only set Content-Type for JSON, let browser set it for FormData
    if (!isFormData) {
      headers["Content-Type"] = "application/json";
      headers["Accept"] = "application/json";
    }

    const response = await fetch(apiUrl + "/projects/update/", {
      method: "PUT",
      headers: headers,
      body: isFormData ? data : JSON.stringify(data),
    });

    const responseData = await response.json();

    return responseData;
  } catch (error) {
    return error;
  }
};

export const saveProject = async (project) => {
  try {
    const token = localStorage.getItem("accessToken");

    const response = await fetch(apiUrl + "/projects/", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
      },
      body: project,
    });

    const responseData = await response.json();

    if (!response.ok) {
      // Handle different error response formats
      if (responseData.message) {
        throw new Error(responseData.message);
      }

      // Handle field-specific errors (like validation errors)
      const errorObj = { status: response.status, errors: {} };

      // Check if responseData itself is an array (general errors)
      if (Array.isArray(responseData)) {
        errorObj.errors.general = responseData;
      } else {
        // Check each field for errors
        Object.keys(responseData).forEach((key) => {
          if (Array.isArray(responseData[key])) {
            errorObj.errors[key] = responseData[key];
          } else if (typeof responseData[key] === "string") {
            errorObj.errors[key] = [responseData[key]];
          }
        });
      }

      throw errorObj;
    }

    return responseData;
  } catch (error) {
    throw error;
  }
};

export const updateProject = async (project) => {
  try {
    const token = localStorage.getItem("accessToken");

    const response = await fetch(apiUrl + "/projects/update", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
      },
      body: project,
    });

    const responseData = await response.json();

    if (!response.ok) {
      throw new Error(responseData.message || "Failed to save project");
    }

    return responseData;
  } catch (error) {
    throw error;
  }
};

export const deleteProject = async () => {
  try {
    const token = localStorage.getItem("accessToken");

    const response = await fetch(`${apiUrl}/projects/delete/`, {
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + token,
      },
    });

    const responseData = await response.json();

    return responseData;
  } catch (error) {
    return error;
  }
};

export const duplicateProject = async (projectId) => {
  try {
    const token = localStorage.getItem("accessToken");

    const response = await fetch(`${apiUrl}/projects/${projectId}/duplicate/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
    });

    const responseData = await response.json();

    if (!response.ok) {
      throw new Error(responseData.error || "Failed to duplicate project");
    }

    return responseData;
  } catch (error) {
    throw error;
  }
};
